// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
  overflow-x: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

@media (max-width: 768px) {
  .container {
    padding: 10px;
  }
}

.card {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  max-width: 100%;
}

@media (max-width: 768px) {
  .card {
    padding: 15px;
    border-radius: 12px;
  }
  
  /* Mobile Tabellen: Vertikal stapeln */
  .card table, .card thead, .card tbody, .card th, .card td, .card tr {
    display: block;
  }
  
  .card thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  
  .card tr {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    margin-bottom: 8px;
    padding: 12px;
    background: #f8f9fa;
    box-shadow: none;
  }
  
  .card td {
    border: none;
    padding: 4px 0;
    position: relative;
    padding-left: 35% !important;
    font-size: 13px;
    line-height: 1.3;
  }
  
  .card td:before {
    content: attr(data-label) ":";
    position: absolute;
    left: 0;
    width: 32%;
    text-align: left;
    font-weight: 600;
    color: #495057;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding-right: 8px;
  }
  
  /* Buttons in Mobile Cards kleiner machen */
  .card .btn-sm {
    padding: 4px 8px !important;
    font-size: 11px !important;
    border-radius: 6px;
  }
  
  /* Badges kompakter */
  .card .badge {
    padding: 2px 6px;
    font-size: 10px;
    border-radius: 6px;
  }
}

/* Entfernter Hover-Effekt für Cards */

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.btn-primary {
  background-color: #2c5364;
  color: white;
}

.btn-danger {
  background-color: #dc3545;
  color: white;
}

.btn-success {
  background-color: #28a745;
  color: white;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #2c5364;
  box-shadow: 0 0 0 3px rgba(44, 83, 100, 0.15);
}

.error {
  color: #dc3545;
  font-size: 14px;
  margin-top: 5px;
}

.success {
  color: #28a745;
  font-size: 14px;
  margin-top: 5px;
}

.nav {
  background: white;
  padding: 15px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  overflow-x: hidden;
}

.nav ul {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
}

@media (max-width: 768px) {
  .nav {
    padding: 10px;
  }
  
  .nav ul {
    gap: 8px;
    font-size: 13px;
  }
  
  .nav ul li {
    white-space: nowrap;
  }
}

.nav a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
}

.nav a:hover {
  color: #2c5364;
  border-bottom: 2px solid #2c5364;
}

.nav a.active {
  color: #2c5364;
  font-weight: 600;
  border-bottom: 2px solid #2c5364;
}

table {
  width: 100%;
  border-collapse: collapse;
}

@media (min-width: 769px) {
  table th,
  table td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }
  
  table th {
    background-color: #f8f9fa;
    font-weight: 600;
    color: #495057;
  }
}

@media (max-width: 768px) {
  table th,
  table td {
    padding: 0;
    border: none;
  }
}

table th {
  background-color: #f8f9fa;
  font-weight: 600;
}

table tbody tr {
  border-left: 3px solid transparent;
  transition: background-color 0.2s ease;
}

table tbody tr:hover {
  background-color: rgba(44, 83, 100, 0.05);
  border-left-color: #2c5364;
}

/* Beschreibungsspalten: Lange Texte mit Ellipsis abschneiden */
table td[data-label="Beschreibung"] {
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.badge-success {
  background-color: #d4edda;
  color: #155724;
}

.badge-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.badge-warning {
  background-color: #fff3cd;
  color: #856404;
}

.badge-info {
  background-color: #d1ecf1;
  color: #0c5460;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #666;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  padding: 30px;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.modal-content h2 {
  margin-bottom: 15px;
  color: #333;
}

.btn-sm {
  padding: 5px 10px;
  font-size: 13px;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.form-control {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-control:focus {
  outline: none;
  border-color: #2c5364;
  box-shadow: 0 0 0 3px rgba(44, 83, 100, 0.15);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA,sCAAsC;EACtC;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA,2CAA2C;EAC3C;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA,qBAAqB;EACrB;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,sCAAsC;;AAEtC;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,aAAa;IACb,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE;;IAEE,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA,+DAA+D;AAC/D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f5f5f5;\n  overflow-x: hidden;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 10px;\n  }\n}\n\n.card {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  max-width: 100%;\n}\n\n@media (max-width: 768px) {\n  .card {\n    padding: 15px;\n    border-radius: 12px;\n  }\n  \n  /* Mobile Tabellen: Vertikal stapeln */\n  .card table, .card thead, .card tbody, .card th, .card td, .card tr {\n    display: block;\n  }\n  \n  .card thead tr {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n  \n  .card tr {\n    border: 1px solid #e9ecef;\n    border-radius: 8px;\n    margin-bottom: 8px;\n    padding: 12px;\n    background: #f8f9fa;\n    box-shadow: none;\n  }\n  \n  .card td {\n    border: none;\n    padding: 4px 0;\n    position: relative;\n    padding-left: 35% !important;\n    font-size: 13px;\n    line-height: 1.3;\n  }\n  \n  .card td:before {\n    content: attr(data-label) \":\";\n    position: absolute;\n    left: 0;\n    width: 32%;\n    text-align: left;\n    font-weight: 600;\n    color: #495057;\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    padding-right: 8px;\n  }\n  \n  /* Buttons in Mobile Cards kleiner machen */\n  .card .btn-sm {\n    padding: 4px 8px !important;\n    font-size: 11px !important;\n    border-radius: 6px;\n  }\n  \n  /* Badges kompakter */\n  .card .badge {\n    padding: 2px 6px;\n    font-size: 10px;\n    border-radius: 6px;\n  }\n}\n\n/* Entfernter Hover-Effekt für Cards */\n\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.btn:hover {\n  opacity: 0.9;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0,0,0,0.15);\n}\n\n.btn-primary {\n  background-color: #2c5364;\n  color: white;\n}\n\n.btn-danger {\n  background-color: #dc3545;\n  color: white;\n}\n\n.btn-success {\n  background-color: #28a745;\n  color: white;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 500;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #2c5364;\n  box-shadow: 0 0 0 3px rgba(44, 83, 100, 0.15);\n}\n\n.error {\n  color: #dc3545;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n.success {\n  color: #28a745;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n.nav {\n  background: white;\n  padding: 15px 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n  overflow-x: hidden;\n}\n\n.nav ul {\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  align-items: center;\n}\n\n@media (max-width: 768px) {\n  .nav {\n    padding: 10px;\n  }\n  \n  .nav ul {\n    gap: 8px;\n    font-size: 13px;\n  }\n  \n  .nav ul li {\n    white-space: nowrap;\n  }\n}\n\n.nav a {\n  text-decoration: none;\n  color: #333;\n  font-weight: 500;\n}\n\n.nav a:hover {\n  color: #2c5364;\n  border-bottom: 2px solid #2c5364;\n}\n\n.nav a.active {\n  color: #2c5364;\n  font-weight: 600;\n  border-bottom: 2px solid #2c5364;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n@media (min-width: 769px) {\n  table th,\n  table td {\n    padding: 12px;\n    text-align: left;\n    border-bottom: 1px solid #ddd;\n  }\n  \n  table th {\n    background-color: #f8f9fa;\n    font-weight: 600;\n    color: #495057;\n  }\n}\n\n@media (max-width: 768px) {\n  table th,\n  table td {\n    padding: 0;\n    border: none;\n  }\n}\n\ntable th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n}\n\ntable tbody tr {\n  border-left: 3px solid transparent;\n  transition: background-color 0.2s ease;\n}\n\ntable tbody tr:hover {\n  background-color: rgba(44, 83, 100, 0.05);\n  border-left-color: #2c5364;\n}\n\n/* Beschreibungsspalten: Lange Texte mit Ellipsis abschneiden */\ntable td[data-label=\"Beschreibung\"] {\n  max-width: 250px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.badge-success {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.badge-danger {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.badge-warning {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.badge-info {\n  background-color: #d1ecf1;\n  color: #0c5460;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  padding: 30px;\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.modal-content h2 {\n  margin-bottom: 15px;\n  color: #333;\n}\n\n.btn-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n.btn-secondary {\n  background-color: #6c757d;\n  color: white;\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.form-control {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.form-control:focus {\n  outline: none;\n  border-color: #2c5364;\n  box-shadow: 0 0 0 3px rgba(44, 83, 100, 0.15);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
